import React, { useEffect } from "react";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { Form, Button, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CollectionReptile } from "../types/CollectionTypes.ts";
import { ListingItem } from "../../utilities/CollectionGroup.tsx";
import { LoginContainer } from "../../Login.tsx";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Loading } from "../../Loading.tsx";
import { useRepToolContext } from '../../../RepToolContext.tsx';
const INQUIRY_OPTIONS = {
  INQUIRE_TO_BUY: "I want to buy this reptile",
  GENERAL_INQUIRY: "I have a question about this reptile",
  OFFER: "I want to make an offer on this reptile",
  OTHER: "Other"
}

export const InquireToBuyModal = ({
  closeModal,
  reptile
}: {
  closeModal: () => void;
  reptile: CollectionReptile;
}) => {
  const [subject, setSubject] = React.useState(INQUIRY_OPTIONS.INQUIRE_TO_BUY);
  const [message, setMessage] = React.useState("");
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [selectedInquiryOption, setSelectedInquiryOption] = React.useState(INQUIRY_OPTIONS.INQUIRE_TO_BUY);
  const [fetching, setFetching] = React.useState(true);
  const { appendControls } = useRepToolContext();

  const checkIfLoggedIn = () => {
    const url = `${(window as any).serverLocation}/user/get_user?api_key=${localStorage.getItem("reptoolCookie")}`;
    fetch(url, {
      method: "GET",
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.message !== 'Bad token') {
          (window as any).currentUser = { ...data }
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      }).finally(() => {
        setFetching(false);
      })
      .catch((error) => {
        return false;
      });
  }

  const sendMessage = (e) => {
    e.preventDefault();
    if (!selectedInquiryOption) {
      (window as any).alert("Please select an inquiry subject.");
      return;
    }
    BasicFetch({
      url: `${(window as any).serverLocation}/collection_reptile/${reptile.uuid}/inquire`,
      method: "POST",
      data: {
        subject,
        message
      },
      onSuccess: (data) => {
        (window as any).alert("Message sent successfully!");
        closeModal();
      },
      onFail: () => {
        (window as any).alert("Failed to send message. Please try again later.");
      }
    })
  }
  useEffect(() => {
    appendControls(null, 'Inquire To Buy Modal');
    checkIfLoggedIn();
  }, [isLoggedIn]);
  return (
    <ReptoolModal
      id='inquire-to-buy-modal'
      title="Inquiry Form"
      closeModal={closeModal}
      body={
        <>
          {fetching ? <Loading /> : <>
            {isLoggedIn ? <>
            <div className="d-flex justify-content-center">
              <ListingItem reptile={reptile} hideButton />
            </div>
              <Form onSubmit={sendMessage}>
                <Form.Group>
                  <Form.Label>Inquiry Subject</Form.Label>
                  <Form.Control
                    as="select"
                    className="bg-dark text-light"
                    value={selectedInquiryOption}
                    onChange={(e) => setSelectedInquiryOption(e.target.value)}
                  >
                    <option value=''>Inquiry subjects</option>
                    {Object.values(INQUIRY_OPTIONS).map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {selectedInquiryOption === 'Other' && <Form.Group className="mt-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    className="bg-dark text-light"

                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </Form.Group>}
                <Form.Group className="my-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    className="bg-dark text-light"
                    value={message}
                    rows={3}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>
                <Button
                  variant='outline-light'
                  disabled={(window as any).currentUser?.id === reptile.user_gid}
                  className='w-100'
                  type="submit"
                >Send</Button>
                {(window as any).currentUser?.id === reptile.user_gid && <Alert variant="info" className="mt-3">
                  <div className="d-flex w-100">
                    <FontAwesomeIcon className="my-auto" size="lg" icon={faInfoCircle} />
                    <h5 className="text-info ml-4 my-auto">You cannot send an inquiry to yourself.</h5>
                  </div>
                </Alert>}
              </Form>
            </> : <div>
              <Alert variant="info">
                <div className="d-flex w-100">
                  <FontAwesomeIcon className="my-auto" size="lg" icon={faInfoCircle} />
                  <h5 className="text-info ml-4 my-auto">Please log in or create an account to send an inquiry.</h5>
                </div>
              </Alert>
              <LoginContainer showMenu={() => setIsLoggedIn(true)} showFrame={false} />
            </div>}
          </>}
        </>
      } />
  )
}